/**
 *  Filename ....: automatch.component.ts
 *  Created by ..: ianday
 *  on Date .....: 2/28/24
 **/
import {Component, OnInit} from '@angular/core';
import {UserService} from "../../../../../services/user.service";
import {Settings} from "../../../../../services/settings";
import {GeneralService} from "../../../../../services/general.service";
import {DwUtils} from "../../../../../components/utils/dw-utils";

@Component({
    selector: 'app-automatch',
    templateUrl: './automatch.component.html',
    styleUrls: ['./automatch.component.css']
})

export class AutomatchComponent implements OnInit {

    public enabledList:any;
    public selectedValue: string;
    public settingsRecord: any;
    public currentRunState: string;

    public viewLogDlg: boolean = false;
    public headerRecords: any;
    public detailRecords: any
    public successCount: number = 0;

    public logContent: string;

    public visibleModify: boolean = false;

    constructor(public settingsService: UserService, public generalService:GeneralService) {
        this.enabledList = [];
        this.enabledList.push({id: 'true', description: 'Enabled'});
        this.enabledList.push({id: 'false', description: 'Disabled'});

    }

    ngOnInit() {
        if(Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_AUTOMATCH', "WRITE")) {
           this.visibleModify = true;
        }
        this.settingsRecord = Settings.getInstance().getGeneralSettingByKey('automatchservice');
        this.selectedValue = this.settingsRecord.value;
        this.currentRunState = this.displayCurrentState(this.selectedValue);
        this.queryLogRecords();
    }

    public updateIntegrationStatus(val: any):void {

        this.settingsRecord.value = val;
        this.settingsService.createUpdateSetting(this.settingsRecord).subscribe(
            (result) => {
                this.currentRunState = this.displayCurrentState(this.selectedValue);
            },
            (error) => {
                Settings.getInstance().handleError(error, 'Updating automatch service setting');
            });
    }
    public displayCurrentState(runningState: string): string {

        if(runningState === "true") {
            return 'Running ...';
        }

        return 'Suspended ... ';
    }
    public doOpenViewLog(): void {
        this.viewLogDlg = true;

      //  this.queryLogRecords();
    }
    public queryLogRecords():void {
        this.headerRecords = [];
        this.detailRecords = [];
        this.generalService.getMatchLogRecords().subscribe(
            (results) => {
                this.headerRecords = results.header;
                this.detailRecords = results.detail;
                this.setRecordsForShow();
             },
            (error) => {
                Settings.getInstance().handleError(error, 'Fetching matchlog records');
            }
        )

    }
    public setRecordsForShow():void  {

        let i = 0;
        this.logContent = '';
        this.successCount = 0;

        for(const rec of this.headerRecords) {
            this.logContent += 'Auto-Match Run .............: <b>'+ DwUtils.formatUTCToTZDate(rec.runTime) + '</b><BR />';
            this.logContent += 'Records Processed .......: <b>'+ rec.recordsProcessed + '</b><BR />';
            this.logContent += 'Records Matched ..........: <b>'+ rec.recordsMatched + '</b><BR />';
            this.logContent += 'Max attempts reached ..: <b>'+ rec.recordsReachedMaxAttempts + '</b><BR />';

           for(let i=0; i < this.detailRecords.length; i++) {
               const detail = this.detailRecords[i];

               if(detail.matchLogHeaderId === rec.id) {
                   this.logContent += '<BR /><b>------------------------------------------------------------</b><BR' +
                       ' />';
                   this.logContent += 'Case Number .....: <b>' + detail.caseNumber + '</b><BR />';
                   this.logContent += 'First/Last Name .: <b>' + detail.firstName + ' ' + detail.lastName + '</b><BR' +
                       ' />';
                   this.logContent += 'Request Type ....: <b>' + detail.description + '</b><BR />';
                   this.logContent += '<b>------------------------------------------------------------</b><BR />';

                   const lineResult = detail.log.split('\n');

                   if(lineResult !== undefined) {
                       const numLines = lineResult.length;
                       let i = 0;
                       for(const line of lineResult) {

                           if(i === numLines -1) {
                               if(line.includes('Assigning') === true) {
                                   this.logContent += '<b>&nbsp + [SUCCESS] ' + line + '</span></b><BR />';
                                   this.successCount++;
                               }
                               else {
                                   this.logContent += '<b>&nbsp - [FAILED] ' + line + '</b><BR />';
                               }
                           }
                           else {
                               this.logContent += '&nbsp - ' + line + ' ...<BR />';
                           }
                           i++;
                       }
                       this.logContent += '<BR />'
                   }
               }
           }
        }

    }

}


